import React, { useEffect, useState } from 'react'
import SignatureUtil from '../utils/signature.util'
import CanvasDraw from 'react-canvas-draw'

/**
 * @return {{width: number, height: number, updateDimensions: Function}} 
 */
const useCanvasDimensions = () => {
    const [dimensions, setDimensions] = useState({ width: SignatureUtil.MAX_WIDTH, height: SignatureUtil.MAX_HEIGHT })


    /**
    * @param {import('react').MutableRefObject<any>} ref
    * 
    */
    function updateDimensions(ref) {
        if (ref && ref.current) {
            // Ancho disponible del contenedor padre
            const containerWidth = ref.current.canvasContainer.clientWidth;

            // Para dispositivos móviles (usando ancho como referencia)
            if (containerWidth < SignatureUtil.MAX_WIDTH) {
                const aspectRatio = SignatureUtil.MAX_HEIGHT / SignatureUtil.MAX_WIDTH;
                const newHeight = containerWidth * aspectRatio;

                setDimensions({
                    width: containerWidth,
                    height: newHeight
                });
            } else {
                // Mantener dimensiones máximas en escritorio
                setDimensions({
                    width: SignatureUtil.MAX_WIDTH,
                    height: SignatureUtil.MAX_HEIGHT
                });
            }
        }
    };

    useEffect(() => {
        updateDimensions();

        window.addEventListener('resize', updateDimensions);

        return () => window.removeEventListener('resize', updateDimensions);
    }, [])
    return { width: dimensions.width, height: dimensions.height, updateDimensions }
}

export default useCanvasDimensions